// extracted by mini-css-extract-plugin
export default {"Blackberry":"#333D47","FontWeightBold":"600","navExtenedItemLink":"HeaderNavExtendedItemLink_navExtenedItemLink__pWWT7 typography_fontStyleBody__-8KSo"};